import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthenticationGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private cookieService: CookieService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.authenticationService.isAuthenticated && !this.authenticationService.isTwoFactorSetupActive) {
      return true;
    } else if (this.authenticationService.isAuthenticated && this.authenticationService.isTwoFactorSetupActive) {
      this.router.navigate(['/account/two-factor-setup']);
      return false;
    } else {
      this.router.navigate(['/account/login']);
      return false;
    }
  }
}
